import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { RDDarkService } from '../dark.service';

@Component({
  selector: 'rd-input-number',
  template: `<div class="inputNumberContainer {{color}}InputNumber" [class.rdDark]="dark">
  <div class="labelInputNumber" *ngIf="label">
    {{label}}
  </div>

  <div class="inputNumber">
    <ng-container *ngIf="display === 'both'">
      <span class="incrementorBoth" [class.disabled]="disabled" (click)="incrementValue(-increment)">
        <i class="fas fa-minus"></i>
      </span>
    </ng-container>
    <div class="numberContainer">
      <span>{{value}}</span>
    </div>
    <ng-container *ngIf="display === 'both'">
      <span class="incrementorBoth" [class.disabled]="disabled" (click)="incrementValue(increment)">
        <i class="fas fa-plus"></i>
      </span>
    </ng-container>
    <div *ngIf="display === 'single'" class="incrementorSingle">
      <span (click)="incrementValue(-increment)" [class.disabled]="disabled">
        <i class="fas fa-minus"></i>
      </span>
      <span (click)="incrementValue(increment)" [class.disabled]="disabled">
        <i class="fas fa-plus"></i>
      </span>
    </div>
  </div>

</div>
`,
  styles: [`.inputNumberContainer{--main-color:#ba9e5a;--text-color:black;transition:all .3s linear}.inputNumberContainer .labelInputNumber{color:var(--text-color);font-size:13px;padding-left:6px}.inputNumberContainer:hover .labelInputNumber{color:var(--main-color)}.inputNumberContainer .inputNumber{display:flex}.inputNumberContainer .inputNumber .incrementorBoth{color:#fff;background-color:var(--main-color);padding:3px 6px;border-radius:50% 0 0 50%;cursor:pointer}.inputNumberContainer .inputNumber .incrementorBoth:last-of-type{border-radius:0 50% 50% 0}.inputNumberContainer .inputNumber .incrementorSingle{display:flex;flex-direction:column}.inputNumberContainer .inputNumber .incrementorSingle span{cursor:pointer;color:#fff;background-color:var(--main-color);padding:2px 3px}.inputNumberContainer .inputNumber .incrementorSingle span:last-of-type{border:solid #fff;border-width:1px 0 0}.inputNumberContainer .inputNumber .numberContainer{padding:3px 6px;flex:1;border:1px solid var(--main-color);overflow:hidden;position:relative;color:var(--text-color)}.inputNumberContainer .inputNumber .numberContainer span{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.inputNumberContainer .inputNumber span.disabled{cursor:not-allowed}.inputNumberContainer.greenInputNumber{--main-color:#72ba5a}.inputNumberContainer.blueInputNumber{--main-color:#5a5aba}.inputNumberContainer.blue-lightInputNumber{--main-color:#5aa2ba}.inputNumberContainer.redInputNumber{--main-color:#ba5a5a}.inputNumberContainer.purpleInputNumber{--main-color:#a25aba}.inputNumberContainer.orangeInputNumber{--main-color:#ba8a5a}.inputNumberContainer.rdDark{--text-color:white}`]
})
export class RDInputNumberComponent implements OnInit {

  @Input() value = 1;
  @Input() label = null;
  @Input() color = 'gold';
  @Input() display = 'both';
  @Input() min = null;
  @Input() max = null;
  @Input() increment = 1;
  @Input() disabled = false;

  @Output() valueChange: EventEmitter<any> = new EventEmitter();

  public dark = false;

  constructor(private darkService: RDDarkService) { }

  ngOnInit() {
    this.darkService.getDarkElement().subscribe(() => {
      this.dark = this.darkService.isDark();
    });
    this.dark = this.darkService.isDark();
  }

  incrementValue(increment) {
    if (!this.disabled) {
      const newValue = this.value + increment;
      if (this.min != null && newValue < this.min) {
        this.value = this.min;
      } else if (this.max != null && newValue > this.max) {
        this.value = this.max;
      } else {
        this.value = newValue;
      }
      this.valueChange.emit(this.value);
    }
  }

}
